export const getters = {
  systemPettycashes: state => state.pettycashes
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettycashes/getters.js